import api from '@/api/articleApi';
import BaseModule from "@/common/BaseModule";
import { Module, Store } from "vuex";
import { LOAD_ARTICLES_HOME, SEO } from '../protocols';
export interface State {
    categories: ArticleCategory[],
    category: string,
    feeds: ArticleFeed[],
    aTops: ArticleFeedItem[],
    tops: ArticleFeedItem[],
    feedIndex: number,
    feedsVisible: boolean,
    article: Article | null,
}
class ArticleHome extends BaseModule<State> {
    constructor() {
        super(LOAD_ARTICLES_HOME[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                categories: [],
                category: '',
                aTops: [],
                tops: [],
                feeds: [],
                feedIndex: -1,
                feedsVisible: true,
                article: null,
            },
            mutations: {
                updateArticle(state, data) {
                    state.article = data
                }
            },
            actions: {
                async loadCategories({ state }, route: Route) {
                    if (state.categories.length == 0) {
                        try {
                            state.categories = await api.getCategorys()
                            let { tops } = await api.getFeedsV2(1, 1)
                            state.aTops = tops
                        } catch (e) {
                        }
                    }
                },
                async loadFeeds({ state, dispatch }, key: string) {
                    if (state.category != key) {
                        try {
                            let { tops, users } = await api.getFeedsV2(1, 7, key)
                            state.tops = tops
                            state.feeds = users
                            state.category = key
                        } catch (e) {
                            state.feeds = []
                        } finally {
                            state.feedIndex = -1
                        }
                    }
                },
                async loadContent({ dispatch, commit, state }, route: Route) {
                    if (state.feeds.length == 0) {
                        await dispatch('loadFeeds', 'ttlx')
                    }
                    try {
                        let id = route.params.id || state.feeds[0].list[0].itemid
                        state.article = await api.getDetail(id)
                        let seoTitle = state.article.title + '-福音阅读-福音影视网|福音TV'
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    } catch (e) {
                    }
                },
                [LOAD_ARTICLES_HOME[1]]({ dispatch, state, commit }, route: Route) {
                    return Promise.all([
                        dispatch('loadCategories', route),
                        dispatch('loadContent', route),
                        // dispatch(LOAD_SEO, { file: 'hot' }, { root: true })
                    ])
                }
            }
        }
    }

    setCategory(store: Store<any>, key: string) {
        return store.dispatch(this.key('loadFeeds'), key)
    }
}

export default new ArticleHome();